export default {
  updateFilterStartDate: (state, init_date) =>
    (state.filter.init_date = init_date),
  updateFilterEndDate: (state, end_date) => (state.filter.end_date = end_date),
  updateFilterSeller: (state, seller) => {
    state.filter.seller = seller
  },
  updateFilterCredit: (state, payload) => (state.filter.credit = payload),
  updateFilterBaseDebt: (state, payload) => (state.filter.base_debt = payload),
  updateFilterCoverage: (state, payload) => (state.filter.coverage = payload),
  updateFilterChain: (state, chainOption) => (state.filter.chain = chainOption),
  updateFilterPos: (state, posOption) => (state.filter.pos = posOption),
  updateFilterCustomerDocument: (state, customerDocument) =>
    (state.filter.customer_document = customerDocument)
}
